<template>
	<div>
		<botao-tooltip
			id="botao-visualizar"
			icone="mdi-eye"
			v-if="autorizadoNoFluxo(permissoes.pedidoUtilizacaoPenalidadesVisualizar)"
			v-az-auth="permissoes.pedidoUtilizacaoPenalidadesVisualizar"
			cor="grey"
			texto="Visualizar"
			@click="$emit('visualizar', item)"
		></botao-tooltip>
		<botao-tooltip
			id="botao-editar"
			icone="mdi-pencil"
			v-if="podeExibirBotao(item.usuarioPodeEditar, permissoes.pedidoUtilizacaoPenalidadesEditar)"
			v-az-auth="permissoes.pedidoUtilizacaoPenalidadesEditar"
			cor="grey"
			texto="Editar"
			@click="$emit('editar', item)"
		></botao-tooltip>
		<botao-tooltip
			id="botao-excluir"
			icone="mdi-delete"
			v-if="
				!item.ehSancao &&
				podeExibirBotao(item.usuarioPodeExcluir, permissoes.pedidoUtilizacaoPenalidadesExcluir)
			"
			v-az-auth="permissoes.pedidoUtilizacaoPenalidadesExcluir"
			cor="grey"
			texto="Excluir"
			@click="$emit('excluir', item)"
		></botao-tooltip>
		<botao-tooltip
			id="botao-historico-notificacoes"
			icone="mdi-history"
			v-if="
				podeExibirBotao(
					item.usuarioPodeVisualizarHistoricoNotificacoes,
					permissoes.pedidoUtilizacaoPenalidadesHistoricoNotificacoes,
				) && item.possuiInfracao
			"
			v-az-auth="permissoes.pedidoUtilizacaoPenalidadesHistoricoNotificacoes"
			cor="grey"
			texto="Histórico de Notificações"
			@click="$emit('historico-notificacoes', item)"
		></botao-tooltip>
	</div>
</template>
<script>
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import BotaoTooltip from '@/views/components/BotaoTooltip.vue'

export default {
	name: 'listagem-penalidades-pedido-botoes-acoes',
	components: { BotaoTooltip },
	mixins: [permissoesMixin],
	props: {
		item: {
			type: Object,
			required: true,
		},
		autorizadoNoFluxo: {
			type: Function,
			required: true,
		},
	},
	methods: {
		podeExibirBotao(temPermissao, permissao) {
			return temPermissao && this.autorizadoNoFluxo(permissao)
		},
	},
}
</script>
<style scoped lang="stylus">
.justify-content-center
	justify-content center
</style>
